import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface Testimonial {
  name: string;
  rating: number;
  text: string;
  seed: string; // Para gerar avatares aleatórios consistentes
}

export function useNewLp() {
  const navigate = useNavigate();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [direction, setDirection] = useState<'next' | 'prev'>('next');

  const testimonials: Testimonial[] = [
    {
      name: "Julia Silva",
      rating: 5,
      text: "Com a Precision, aprendi a analisar eficientemente os jogos e isso me trouxe uma taxa de sucesso em apostas que nunca imaginei ser possível. A plataforma é simplesmente incrível!",
      seed: "julia-silva"
    },
    {
      name: "Rômulo Pedra",
      rating: 5,
      text: "Não consigo mais imaginar fazer apostas sem o auxílio da inteligência artificial. É como ter um supercomputador nas pontas dos dedos! Os resultados falam por si.",
      seed: "romulo-pedra"
    },
    {
      name: "Carlos Mendes",
      rating: 5,
      text: "A precisão das análises é impressionante. Em poucos meses, consegui resultados que antes levariam anos para alcançar. A IA realmente revolucionou minha forma de apostar.",
      seed: "carlos-mendes"
    },
    {
      name: "Ana Beatriz",
      rating: 5,
      text: "Interface intuitiva e resultados consistentes. A Precision me ajudou a transformar apostas em um investimento sério e lucrativo. Recomendo fortemente!",
      seed: "ana-beatriz"
    },
    {
      name: "Rafael Costa",
      rating: 5,
      text: "As análises em tempo real são um diferencial incrível. A plataforma me dá confiança para tomar decisões mais assertivas. Melhor investimento que já fiz!",
      seed: "rafael-costa"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection('next');
      setCurrentTestimonial(prev => (prev === testimonials.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const handleTestimonialChange = (index: number) => {
    setDirection(index > currentTestimonial ? 'next' : 'prev');
    setCurrentTestimonial(index);
  };

  const handleRegisterClick = () => {
    navigate('/register?af=9');
  };

  const handleLoginClick = () => {
    navigate('/login');
  };

  return {
    currentTestimonial,
    setCurrentTestimonial: handleTestimonialChange,
    testimonials,
    direction,
    handleRegisterClick,
    handleLoginClick
  };
}

export default useNewLp;